export const colors = {
    main: "#00b0bb",
    bg: "#f8f9fb",
    text: "#04222b",
    lightBlue: "#e2eeff",
    darkGreen: "#042b20",
};
